/** DEMO-ONLY: SKU → productName from mock product get.json files. */
export const PRESIDIO_MOCK_PRODUCT_NAMES: Record<string, string> = {
  "PRS-AI-STARTER": "AI Starter Bundle",
  "DELL-AI-STOR-60": "AI Data Lake Storage 60TB",
  "AMD-MI300X": "AMD Instinct MI300X Node",
  "AMD-MI325X": "AMD Instinct MI325X Cluster Node",
  "DCS-7050X3": "Arista 7050X3",
  "DCS-7130": "Arista 7130",
  "CCS-720XP": "Arista 720XP",
  "DCS-7280R3": "Arista 7280R3",
  "DCS-7800R3": "Arista 7800R3",
  "CL-15": "Targus CityLite Laptop Backpack 15\"",
  "1250g": "Honeywell Voyager 1250g Barcode Scanner",
  "SMX120BP": "UPS Extended Battery Pack",
  "BDL-AI-LAB": "AI Lab Starter Bundle",
  "BDL-CLOUD": "Private Cloud Bundle",
  "BDL-EDGE": "Secure Edge Bundle",
  "BDL-SEC": "Security Stack Bundle",
  "C210E": "GBC CombBind C210e Binder",
  "HPE-C7000": "HPE BladeSystem c7000 Kit",
  "USB4-08": "USB4 40Gbps Cable 0.8m",
  "C9200-48P": "Cisco Catalyst 9200",
  "CISCO-C9300": "Cisco Catalyst 9300",
  "C9300L-48P": "Cisco Catalyst 9300L",
  "C9400-Chassis": "Cisco Catalyst 9400",
  "C9500-48Y4C": "Cisco Catalyst 9500",
  "FPR-2130": "Cisco Firepower 2130",
  "IE-3400": "Cisco IE-3400",
  "ISE-3695": "Cisco ISE Appliance",
  "N9K-C9336C": "Cisco Nexus 9336C",
  "N9K-C9364D": "Cisco Nexus 9364D",
  "CSF-3105": "Cisco Secure Firewall 3105",
  "UMB-SIG-KIT": "Cisco Umbrella SIG Kit",
  "PRS-BARE-1": "Presidio Bare Metal Pool Node",
  "PRS-CTRL-3": "Presidio Control Plane Trio",
  "PRS-GPU-W1": "Presidio Cloud GPU Worker",
  "PRS-HCI-3": "Presidio HCI Starter Bundle",
  "PRS-K8S-N1": "Presidio Kubernetes Node",
  "DDN-AI200": "DDN AI400 Compact",
  "DDN-AI400X2": "DDN AI400X2",
  "DDN-EXA9": "DDN EXAScaler 9000",
  "DDN-IME": "DDN IME Flash Cache",
  "DDN-SFA18K": "DDN SFA18K",
  "DELL-ECS-EX300": "Dell ECS EX300",
  "DELL-MX760C": "Dell PowerEdge MX760c",
  "DELL-PMAX2500": "Dell PowerMax 2500",
  "DELL-PSTORE500": "Dell PowerStore 500T",
  "DELL-R660": "Dell PowerEdge R660",
  "DELL-R750": "Dell PowerEdge R750",
  "PRS-DELL-R760": "Dell PowerEdge R760",
  "DELL-R760XA": "Dell PowerEdge R760xa",
  "DELL-SC5020": "Dell SC Series Hybrid",
  "DELL-XE8640": "Dell PowerEdge XE8640",
  "DELL-XE9680": "Dell PowerEdge XE9680",
  "DELL-XR11": "Dell PowerEdge XR11",
  "DELL-XR4000": "Dell NativeEdge XR4000",
  "NV-DGX-A100": "NVIDIA DGX A100",
  "NV-DGX-B200": "NVIDIA DGX B200",
  "NV-DGX-GB200": "NVIDIA DGX GB200",
  "NV-DGX-H100": "NVIDIA DGX H100",
  "NV-DGX-STN": "NVIDIA DGX Station A100",
  "TS4": "CalDigit TS4 Thunderbolt Dock",
  "WD19S": "Dell WD19S Docking Station",
  "PRS-EDGE-AP": "Edge Wireless AP",
  "PRS-EDGE-FW": "Edge Firewall Appliance",
  "PRS-IDS-1": "Presidio IDS/IPS Appliance",
  "PRS-EDGE-KIT": "Edge Security Retail Set",
  "PRS-EDGE-MINI": "Presidio Mini Edge Compute",
  "PRS-EDGE-SW": "Edge Access Switch",
  "PRS-VPN-C": "Presidio VPN Concentrator",
  "PRS-WAF-1": "Presidio Edge WAF",
  "FAC-300F": "Fortinet FortiAuthenticator",
  "FAZ-300F": "Fortinet FortiAnalyzer",
  "PRS-FTNT-FG": "Fortinet FortiGate Mid-Range Bundle",
  "FG-100F": "Fortinet FortiGate 100F",
  "FG-600F": "Fortinet FortiGate 600F",
  "FTNT-SASE-B": "FortiSASE Branch Kit",
  "SM-S921": "Samsung Galaxy S24 256GB",
  "SM-G736": "Samsung Galaxy XCover6 Pro",
  "NV-6000-ADA": "NVIDIA RTX 6000 Ada",
  "NV-A40": "NVIDIA A40 Accelerator",
  "NV-A6000": "NVIDIA RTX A6000 Workstation",
  "NV-B100": "NVIDIA B100 Accelerator",
  "NV-H100-PCIE": "NVIDIA H100 PCIe Accelerator",
  "NV-H200-PCIE": "NVIDIA H200 PCIe Accelerator",
  "NV-L4-24G": "Presidio L4 Inference Node",
  "NV-L40-48G": "Presidio L40 Graphics Node",
  "NV-L40S-48G": "Presidio Certified L40S",
  "NV-HGX-B200": "NVIDIA HGX B200",
  "NV-HGX-H100": "NVIDIA HGX H100",
  "NV-HGX-H200": "NVIDIA HGX H200",
  "ED800-G9": "HP EliteDesk 800 G9",
  "ZBOOK-F16": "HP ZBook Fury 16",
  "J9772A": "HPE Aruba 2530",
  "HPE-ALL-6050": "HPE Alletra 6050",
  "R8S96A": "HPE Aruba CX 10000",
  "JL661A": "HPE Aruba CX 6300",
  "JL624A": "HPE Aruba CX 8325",
  "HPE-DL360-G11": "HPE ProLiant DL360 Gen11",
  "PRS-HPE-DL380": "HPE ProLiant DL380 Gen11",
  "HPE-DL380-PERF": "HPE DL380 Performance Kit",
  "HPE-DL560-G11": "HPE ProLiant DL560 Gen11",
  "HPE-EL8000": "HPE Edgeline EL8000",
  "HPE-NIM-HF20": "HPE Nimble HF20",
  "HPE-PRIM-A650": "HPE Primera A650",
  "HPE-RL300": "HPE ProLiant RL300 Gen11",
  "HPE-SO-3660": "HPE StoreOnce 3660",
  "A7516": "Anker 7-Port USB 3.0 Hub",
  "PRS-EDGE-INF": "Presidio Edge Inference Kit",
  "PRS-RAG-1": "Presidio RAG Appliance",
  "IPHONE15-128": "Apple iPhone 15 128GB",
  "IPHONE15P-256": "Apple iPhone 15 Pro 256GB",
  "EX4400-48MP": "Juniper EX4400",
  "EX4650-48Y": "Juniper EX4650",
  "QFX10002-72Q": "Juniper QFX10002",
  "QFX5120-48Y": "Juniper QFX5120",
  "Q1": "Keychron Q1 Mechanical Keyboard",
  "MX-KEYS": "Logitech MX Keys Keyboard",
  "NV-L40S-CFG": "Presidio L40S Configurable",
  "NV-L40S-24": "Presidio L40S 24GB",
  "NV-L40S-24-1U-3Y": "Presidio L40S 24GB 1U / 3 Year",
  "NV-L40S-24-1U-5Y": "Presidio L40S 24GB 1U / 5 Year",
  "NV-L40S-24-2U-3Y": "Presidio L40S 24GB 2U / 3 Year",
  "NV-L40S-24-2U-5Y": "Presidio L40S 24GB 2U / 5 Year",
  "NV-L40S-48": "Presidio L40S 48GB",
  "NV-L40S-48-1U-3Y": "Presidio L40S 48GB 1U / 3 Year",
  "NV-L40S-48-1U-5Y": "Presidio L40S 48GB 1U / 5 Year",
  "NV-L40S-48-2U-3Y": "Presidio L40S 48GB 2U / 3 Year",
  "NV-L40S-48-2U-5Y": "Presidio L40S 48GB 2U / 5 Year",
  "LW-550": "DYMO LabelWriter 550",
  "SATURN3I": "Fellowes Saturn3i A3 Laminator",
  "LAT-5540": "Dell Latitude 5540",
  "LAT-7440": "Dell Latitude 7440",
  "LEN-SE450": "Lenovo ThinkEdge SE450",
  "LEN-SE70": "Lenovo ThinkEdge SE70",
  "LEN-SR630-V3": "Lenovo ThinkSystem SR630 V3",
  "LEN-SR650-V3": "Lenovo ThinkSystem SR650 V3",
  "LEN-SR850-V3": "Lenovo ThinkSystem SR850 V3",
  "T14-G5": "Lenovo ThinkPad T14 Gen 5",
  "MDM-KIT": "Mobile Device Enrollment Kit",
  "E24-G5": "HP E24 G5 FHD Monitor",
  "U2723QE": "Dell UltraSharp 27 4K Monitor",
  "32UN880": "LG UltraFine 32\" 4K Display",
  "S34C650": "Samsung Odyssey 34\" Ultrawide",
  "U4924DW": "Dell UltraSharp 49\" Curved Monitor",
  "45-248-026": "Ergotron Dual Monitor Arm",
  "PRS-MOUSE-OPT": "Presidio Optical USB Mouse",
  "MX3S": "Logitech MX Master 3S Mouse",
  "NTAP-A250": "NetApp AFF A250",
  "NTAP-A400": "NetApp AFF A400",
  "NTAP-A700": "NetApp AFF A700",
  "NTAP-A800": "NetApp AFF A800",
  "NTAP-CVO": "NetApp Cloud Volumes ONTAP",
  "NTAP-FAS2750": "NetApp FAS2750",
  "NTAP-ONTAP-AI": "NetApp ONTAP AI Bundle",
  "NTAP-SG": "NetApp StorageGRID",
  "OPTI-7010": "Dell OptiPlex 7010 Micro",
  "PA-3220": "Palo Alto PA-3220",
  "PA-5450": "Palo Alto PA-5450",
  "PAN-M-100": "Palo Alto Panorama",
  "PAN-PRISMA-K": "Prisma Access Ready Kit",
  "3R02047": "Xerox Vitality Multipurpose Paper (case)",
  "AP8858": "APC Rack PDU 24-Outlet",
  "PX3-5490V": "Raritan PX3 Switched PDU",
  "DEF-UNI": "OtterBox Defender Case (universal)",
  "GA04815": "Google Pixel 8 128GB",
  "PL-4K": "Epson PowerLite 4K Projector",
  "MW632ST": "BenQ MW632ST Short-Throw Projector",
  "4301fdw": "HP Color LaserJet Pro 4301fdw",
  "ZD421": "Zebra ZD421 Label Printer",
  "4001dn": "HP LaserJet Pro 4001dn",
  "MFC-L5900DW": "Brother MFC-L5900DW",
  "T630-24": "HP DesignJet T630 24\"",
  "PSU-1600T": "1600W Titanium Hot-Swap PSU",
  "PURE-CBR": "Pure Cloud Block Store Ready Kit",
  "PURE-CBS-LIC": "Pure Cloud Block Store License",
  "PURE-FAC": "Pure FlashArray//C",
  "PURE-FAX": "Pure FlashArray//X",
  "PURE-FAXL": "Pure FlashArray//XL",
  "PURE-FB": "Pure FlashBlade",
  "PURE-FBE": "Pure FlashBlade//E",
  "PURE-FBX": "Pure FlashBlade//X",
  "PURE-PX-ESS": "Pure Portworx Essentials Kit",
  "PRS-PURE-X20": "Pure FlashArray //X20",
  "KSM56R46BD4": "128GB DDR5 Kit (4x32GB)",
  "CT16G56C46S5": "16GB DDR5 SODIMM",
  "M321R4GA3BB0": "32GB DDR5 ECC RDIMM",
  "M321R8GA0BB0": "64GB DDR5 ECC RDIMM",
  "CT8G4DFRA32": "8GB DDR4 UDIMM",
  "fi-8170": "Fujitsu fi-8170 Document Scanner",
  "DS-1630": "Epson WorkForce DS-1630 Flatbed",
  "PRS-API-SEC": "Presidio API Security Gateway",
  "PRS-DNS-SEC": "Presidio DNS Security Gateway",
  "PRS-EMAIL-SEC": "Presidio Email Security Gateway",
  "PRS-MSEG-1": "Presidio Microseg Gateway",
  "PRS-NAC-1": "Presidio NAC Starter",
  "PRS-OT-SEC": "Presidio OT Security Gateway",
  "PRS-SOC-SENS": "Presidio SOC Sensor Kit",
  "PS-16C": "Fellowes Powershred 16-Sheet Shredder",
  "STU-540": "Wacom STU-540 Signature Pad",
  "SMCI-4U-SDS": "Supermicro 4U Storage Server",
  "SMCI-4L40S": "Supermicro 4x L40S Server",
  "SMCI-HGX-8H100": "Supermicro 8x H100 System",
  "SMCI-EDGE-1": "Supermicro Edge SuperServer",
  "SMCI-1U-GPU": "Supermicro 1U GPU Server",
  "SMCI-221H": "Supermicro SYS-221H",
  "MZ-V8P2T0": "2TB NVMe SSD Gen4",
  "SUPPORT-3YR": "3-Year Hardware Support Subscription",
  "747": "Swingline Heavy-Duty Stapler",
  "PRS-ARCH-1": "Presidio Cold Archive Tier",
  "PRS-ARCH-DISK": "Presidio Tape-less Archive",
  "PRS-BKP-100": "Presidio Backup Target 100TB",
  "PRS-CRYPT-GW": "Presidio Encryption Gateway",
  "PRS-FC-KIT": "Presidio Fibre Channel Kit",
  "PRS-GDS-1": "Presidio GPU Direct Store",
  "PRS-HYB-20": "Presidio Hybrid Array 20TB",
  "PRS-HYB-80": "Presidio Hybrid Array 80TB",
  "PRS-LAB-STOR": "Presidio AI Lab Starter Store",
  "PRS-LAB-STOR2": "Presidio Lab Storage Bundle",
  "PRS-META-1": "Presidio Metadata Indexer",
  "PRS-NAS-48": "Presidio NAS 48-bay",
  "PRS-NFS-GW": "Presidio NFS Gateway",
  "PRS-NVME-100": "Presidio NVMe Array 100TB",
  "PRS-S3-GW": "Presidio S3 Object Gateway",
  "PRS-OBJ-200": "Presidio Object Store 200TB",
  "PRS-OBJ-50": "Presidio Object Store 50TB",
  "PRS-REPL-1": "Presidio Replication Appliance",
  "PRS-SAN-ISCSI": "Presidio SAN Kit iSCSI",
  "PRS-SMB-1": "Presidio SMB Share Appliance",
  "PRS-T2-BUF": "Presidio Tier-2 AI Buffer",
  "PRS-VEEAM-R": "Presidio Veeam Ready Repository",
  "PRS-SVC-AI-ASSESS": "AI Readiness Assessment",
  "SVC-ARCH": "AI Architecture Workshop",
  "SVC-IAC": "Infrastructure Automation",
  "SVC-BKP-OPS": "Backup Operations Service",
  "SVC-CABLE": "Structured Cabling Project",
  "PRS-SVC-DEPLOY": "GPU Cluster Deployment",
  "SVC-DISC": "Infrastructure Discovery",
  "SVC-DR": "DR Design & Test",
  "SVC-FINOPS": "FinOps for Cloud Review",
  "SVC-FW": "Firewall Migration Service",
  "SVC-GPU-OPS": "GPU Cluster Operations",
  "SVC-HEALTH": "Platform Health Check",
  "SVC-K8S": "Kubernetes Platform Build",
  "SVC-MIG": "Data Center Migration",
  "SVC-NET": "Network Refresh Deployment",
  "SVC-NOC": "NOC Monitoring Package",
  "SVC-OPS-MO": "Managed Operations (Mo)",
  "SVC-PATCH": "Patch & Compliance Service",
  "SVC-HYPER": "Hypercare Runbook",
  "SVC-SEC-A": "Security Posture Assessment",
  "SVC-FTE": "Staff Augmentation (FTE)",
  "SVC-STOR": "Storage Platform Deployment",
  "SVC-TRAIN": "Platform Admin Training",
  "SVC-WLAN": "WLAN Survey & Design",
  "SVC-ZT-DES": "Zero Trust Design Service",
  "PRS-CORE-100": "Presidio Core Switch 32x100G",
  "PRS-FAB-KIT": "Presidio Fabric Starter Kit",
  "PRS-IND-8": "Presidio Industrial Switch",
  "PRS-LEAF-25": "Presidio Leaf 48x25G",
  "PRS-MG-24": "Presidio Multi-Gig 24p",
  "PRS-OOB-24": "Presidio OOB Management Switch",
  "PRS-POE-48": "Presidio PoE+ Access 48p",
  "PRS-SPINE-400": "Presidio Spine 32x400G",
  "PRS-WIFI-SW": "Presidio Wi-Fi Uplink Switch",
  "CP-8841": "Cisco IP Phone 8841",
  "CP-8865": "Cisco IP Phone 8865",
  "ATA191": "Cisco ATA 191 Analog Adapter",
  "ISR4331-V": "Cisco ISR 4331 Voice Gateway",
  "VVX-450": "Poly VVX 450 Business Phone",
  "M800": "AudioCodes Mediant 800 SBC",
  "7000E": "Lathem Time Clock 7000e",
  "W2020A": "HP 414A Black Toner Cartridge",
  "W2021-23A": "HP 414A CMY Toner Bundle",
  "HPE-ML350-G11": "HPE ProLiant ML350 Gen11",
  "DELL-T550": "Dell PowerEdge T550",
  "MK2D3": "Apple Magic Trackpad",
  "PRS-TRN-POD4": "Presidio Training Pod (4-node)",
  "IFP4320": "ViewSonic 43\" Interactive Touch Display",
  "UN55CU7000": "Samsung 55\" Crystal UHD TV",
  "QN65Q60C": "Samsung 65\" QLED 4K TV",
  "75UR640S": "LG 75\" 4K UHD Commercial TV",
  "FW-86BZ30L": "Sony 86\" 4K Professional Display",
  "LSM1U": "Chief Large Flat Panel Wall Mount",
  "STUDIO-X50": "Poly Studio X50 Video Bar",
  "RALLY-CAM": "Logitech Rally Camera",
  "EV2-85": "Jabra Evolve2 85 Headset",
  "FOCUS2": "Poly Voyager Focus 2",
  "CS-KIT-MINI": "Cisco Room Kit Mini",
  "SPEAK750": "Jabra Speak 750 Speakerphone",
  "TR-STD": "Microsoft Teams Rooms License (annual)",
  "SMT1500": "APC Smart-UPS 1500VA",
  "SMT3000": "APC Smart-UPS 3000VA",
  "VAST-AI-STOR": "VAST Data AI Storage",
  "VAST-CBOX": "VAST Data CBox Expansion",
  "VAST-DNODE": "VAST Data DNode",
  "VAST-SNAP": "VAST Snapshot Appliance",
  "BRIO-4K": "Logitech Brio 4K Webcam",
  "WEKA-EDGE": "WEKA Edge AI Store",
  "WEKA-NODE": "WEKA Data Platform Node",
  "WEKA-SCALE": "WEKA Scale Unit",
  "PRS-OMNI-WS": "Presidio Omni AI Workstation",
  "PRS-STUDIO": "Presidio Studio Render Node",
  "PRS-IDP-1": "Presidio Identity Proxy",
  "PRS-SASE-1": "Presidio SASE Edge Kit",
};
